export default {
  header: 'Edytuj',
  general: {
    tabLabel: 'Ogólny',
  },
  certificate: {
    tabLabel: 'Certyfikaty',
    ams: {
      amsGroupLabel: 'AMS',
      pyrometry: {
        pyrometryCheckbox: 'AMS2750',
        furnaceClass: 'Klasa pieca',
        instrumentationType: 'Typ instrumentacji',
      },
      heatTreatmentOfSteelParts: 'AMS2759',
    },
    others: {
      objectthersGroupLabel: 'Inni',
      newCertificatesPlaceholder: 'nowe inne certyfikaty',
      instrumentationTypePlaceholder: 'Typ instrumentacji',
    },
  },
  capability: {
    tabLabel: 'Możliwości',
    otherCapabilitiesPlaceholder: 'Inne możliwości',
    temperature: {
      temperatureGroupLabel: 'Temperatura',
      maxTempLabel: 'Maksymalna temperatura',
      minTempLabel: 'Minimalna temperatura',
    },
    dimensions: {
      dimensionsGroupLabel: 'Wymiary',
      diameterLabel: 'Średnica',
      widthLabel: 'Szerokość',
      lengthLabel: 'Długość',
      heightLabel: 'Wysokość',
      maxLoadLabel: 'Maksymalne obciążenie',
    },
  },
  statistics: {
    targetProductivityLabel: 'Docelowa produktywność',
  },
  settings: {
    tabLabel: 'Ustawienia',
    spanGap: 'Próg luki szeregów czasowych',
  },
};
